module.exports = __webpack_public_path__ + "924cf5534e29f4ac513541e3f748c9a3.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/lankenau05.jpg
// module id = 802
// module chunks = 0